"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _makeStyles = _interopRequireDefault(require("../styles/makeStyles"));

var _core = require("@material-ui/core");

var _excluded = ["className"];

var styles = function styles(theme) {
  return {
    root: {
      borderRadius: theme.spacing(1.5)
    }
  };
};

exports.styles = styles;
var useStyles = (0, _makeStyles["default"])(styles);
/**
 * A card container with passthrough props.
 */

var Card = function Card(_ref) {
  var className = _ref.className,
      rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var classes = useStyles();
  return /*#__PURE__*/_react["default"].createElement(_core.Card, (0, _extends2["default"])({
    className: (0, _classnames["default"])(className, classes.root)
  }, rest));
};

var _default = Card;
exports["default"] = _default;